import styled from 'styled-components';

export const DeliverablesList = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;
  margin-top: 16px;
`;
